import { PermissionType } from '@cbinsights/adminpermissionservice/adminpermissionservice';
import { teamPermissions } from 'client/modules/team/permissions/Team';
import {
  getSectionPage,
  useGetAdminPermissionsForUser,
} from 'client/utils/permissions-validation/hooks/UseGetAdminPermissionsForUserQuery';

export const useUserPermissions = () => {
  const { data } = useGetAdminPermissionsForUser();

  const loginAsUserSection = getSectionPage(
    data,
    teamPermissions.pageId,
    teamPermissions.sections[2].sectionId
  );
  const changePackageSection = getSectionPage(
    data,
    teamPermissions.pageId,
    teamPermissions.sections[1].sectionId
  );

  const hasLoginAsUserPermission = loginAsUserSection.permissionTypes.includes(
    PermissionType.PUBLISH
  );
  const hasChangePackagePermission =
    changePackageSection.permissionTypes.includes(PermissionType.PUBLISH);

  return { hasLoginAsUserPermission, hasChangePackagePermission };
};

export default useUserPermissions;
